var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 12.6C8.47502 12.6 7.95002 12.3975 7.55252 12L2.66251 7.10998C2.44501 6.89248 2.44501 6.53248 2.66251 6.31498C2.88001 6.09748 3.24001 6.09748 3.45751 6.31498L8.34752 11.205C8.70752 11.565 9.29252 11.565 9.65252 11.205L14.5425 6.31498C14.76 6.09748 15.12 6.09748 15.3375 6.31498C15.555 6.53248 15.555 6.89248 15.3375 7.10998L10.4475 12C10.05 12.3975 9.52502 12.6 9.00002 12.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/ArrowDownWhite.c3288d7cb0041137390af7e3f4b0509f.svg";
export { ForwardRef as ReactComponent };